import { useState } from 'react';
import { Button, InputNumber, Space } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { useUpdateTransportCostPerKm } from 'api/transports/use-update-transport-cost-per-km';
import type { ICostEditableCellProps } from './types';

export const CostEditableCell = (props: ICostEditableCellProps) => {
  const { costPerKmId, initialCost, addDirty, removeDirty } = props;
  const [value, setValue] = useState<number | null>(initialCost);

  const { mutateAsync: updateCost, isLoading } = useUpdateTransportCostPerKm(costPerKmId);

  const handleChange = (newValue: number | null) => {
    setValue(newValue);

    if (newValue === initialCost) {
      removeDirty(costPerKmId);
    } else {
      addDirty(costPerKmId);
    }
  };

  const handleSave = async () => {
    if (value === null) return;

    await updateCost({ cost: value });
    removeDirty(costPerKmId);
  };

  const isValueNull = value === null;

  return (
    <Space size='small'>
      <InputNumber
        value={value}
        type='number'
        size='small'
        controls={false}
        precision={2}
        status={isValueNull ? 'error' : undefined}
        style={{ width: 80 }}
        onChange={handleChange}
      />
      <Button
        type='text'
        size='small'
        icon={<CheckOutlined />}
        loading={isLoading}
        disabled={isValueNull || value === initialCost}
        onClick={handleSave}
      />
    </Space>
  );
};
